// import { BOUQUET_MY_EXCO, EXCO_SERVICES } from 'const/excoServices';

// export const selectPackagesInCart = createSelector(
//   (state) => state.cartReducer?.currentItems,
//   (currentCartItems) => (currentCartItems ? currentCartItems : [])
// );

export const selectBookmarks = (state) =>
  state.bookmarksReducer?.usefulLinks || [];
